import { UPDATE_ISSUE_BY_PERFORM_ACTION } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_ISSUE_BY_PERFORM_ACTION.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_ISSUE_BY_PERFORM_ACTION.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_ISSUE_BY_PERFORM_ACTION.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
